import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/react-fast-marquee/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/open-source/iconElephant.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/AnimatedLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Card/Card.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/DPE/dpe-cities.png");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/DPE/dpe-computer.png");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/DPE/dpe-summit.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/Hero/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/OpenSource/assets/handshake.svg");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/OpenSource/assets/rocket.svg");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/OpenSource/assets/supporter.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/Pillars/PillarsTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/Productivity/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/Testimonial/netflix.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/sections/product/components/LearnMoreStack/develocity.png");
;
import(/* webpackMode: "eager" */ "/app/src/sections/product/components/LearnMoreStack/dpe-computer.png");
;
import(/* webpackMode: "eager" */ "/app/src/sections/product/components/LearnMoreStack/tablet.png");
